import { UncontrolledDropdown } from 'reactstrap';

export default UncontrolledDropdown;
